import type { DashboardHomeResponse } from "./types";

const CACHE_KEY = "crm:dashboard-home:v1";
const CACHE_TTL_MS = 10 * 60_000;

type CachedDashboardHome = {
    savedAt: number;
    payload: DashboardHomeResponse;
};

export function readDashboardHomeCache(): DashboardHomeResponse | undefined {
    if (typeof window === "undefined") {
        return undefined;
    }

    try {
        const raw = window.sessionStorage.getItem(CACHE_KEY);

        if (!raw) {
            return undefined;
        }

        const parsed = JSON.parse(raw) as CachedDashboardHome;

        if (!parsed?.payload?.summary || typeof parsed.savedAt !== "number") {
            return undefined;
        }

        if (Date.now() - parsed.savedAt > CACHE_TTL_MS) {
            window.sessionStorage.removeItem(CACHE_KEY);
            return undefined;
        }

        return parsed.payload;
    } catch {
        return undefined;
    }
}

export function writeDashboardHomeCache(payload: DashboardHomeResponse) {
    if (typeof window === "undefined" || !payload?.summary) {
        return;
    }

    try {
        const entry: CachedDashboardHome = {
            savedAt: Date.now(),
            payload,
        };

        window.sessionStorage.setItem(CACHE_KEY, JSON.stringify(entry));
    } catch {
        // Ignore quota / private mode errors.
    }
}
